import React from 'react';
import { TextField, Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form';
import { CreateCampaignFormValue } from '@features/Admin/Campaign/model/type';
import { RootState, useAppSelector } from '@shared/store';
import { UserRolesEnum } from '@shared/constants/auth.constants';
import { tss } from 'tss-react/mui';

const useStyles = tss.create(() => ({
  main: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  label: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Plus Jakarta Sans',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '19.6px',
    letterSpacing: '-2%',
  },
}));

interface SharedProductDetailsInputProps {
  rows?: number;
}

const SharedProductDetailsInput: React.FC<SharedProductDetailsInputProps> = ({ rows = 4 }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { control } = useFormContext<CreateCampaignFormValue>();
  const currentUser = useAppSelector((state: RootState) => state.auth.authenticatedUser);

  return (
    <Box className={classes.main}>
      <Typography className={classes.label} variant="h6">
        Product details
      </Typography>
      <Controller
        control={control}
        name="productDetails"
        render={({ field }) => (
          <TextField
            {...field}
            id="product-details"
            disabled={currentUser?.role === UserRolesEnum.VIEWER}
            label={t('campaignPage.placeholders.addProductDetails')}
            value={field.value}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              field.onChange(e.target.value);
            }}
            multiline
            rows={rows}
            variant="outlined"
            fullWidth
          />
        )}
      />
    </Box>
  );
};

export default SharedProductDetailsInput;
